import styled from '@emotion/styled'
import { Box, AccordionSummary } from '@mui/material'
import { colors, typography } from '@resiliatech/birdsong'

export const ImpactReportDashboardContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 24px;
  padding: 0 40px;
  width: auto;
`

export const WidgetLoadingContainer = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'loading' && prop !== 'showBorderAndPadding',
})<{
  height?: string
  loading: boolean
  showBorderAndPadding?: boolean
  width: string
}>`
  background-color: ${colors.background.secondaryBackground};
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  height: ${({ height }) => height};
  justify-content: space-between;
  max-width: 100%;
  overflow: hidden;
  padding: ${({ showBorderAndPadding }) =>
    showBorderAndPadding ? '16px' : '0'};
  transition: all 0.3s;
  width: ${({ width }) => width};
`

export const Dashboard = styled(Box)`
  ${typography.up3.regularSerif};
  color: ${colors.copy.headerDark};
`

export const TwoWidgetContainer = styled(Box)`
  display: flex;
  flex-wrap: nowrap;
  gap: 20px;
  width: 100%;
`

export const SectionHeader = styled(Box)`
  ${typography.up2.regularSerif};
  color: ${colors.copy.headerDark};
`

export const Header = styled(Box)`
  ${typography.up1.regularSerif};
  padding-bottom: 16px;
`

export const StyledAccordionSummary = styled(AccordionSummary)`
  padding: 0;
  min-height: unset;
  opacity: unset !important;

  & .MuiAccordionSummary-content {
    color: ${colors.copy.paragraphDark} !important;
    min-height: unset;
    margin: 0;
  }

  & .Mui-disabled {
  }
`
